import React, {Component} from 'react';
import {translate} from 'react-i18next';
import { Auth } from "aws-amplify";

var Config = require('../../config');

class MenuHandheld extends Component{
	constructor(props){
        super(props);
        
        this.optionClicked = this.optionClicked.bind(this);
	}

	componentDidMount(){
	}

	componentDidUpdate(){
    }
    
    optionClicked(event,option){
        event.preventDefault();
        switch(option){
            case "samples":
                this.props.history.push('/transfusional_control/samples');
                break;
            case 'transfusional_control':
                this.props.history.push('/transfusional_control/list/');
                break;
            case 'incidents':
                this.props.history.push('/transfusional_control/incident/list/');
                break;
        }
    }

    handleLogout = async event => {
		if(sessionStorage.getItem("generic_session_id") !== null){
			fetch(Config.default.apiGateway.URL+'users_generic/'+sessionStorage.getItem("generic_session_id"),{ 
					method: 'PUT',
					headers: new Headers({
						'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
						'Accept': 'application/json',
						'Content-Type': 'application/json',
					})
				})
			.then(response => response.json())
			.then(res => {
                sessionStorage.setItem("token", ""); 
                this.props.userHasAuthenticated(false);
				this.props.history.push("/login");
			})
		}else{
			await Auth.signOut();
			localStorage.clear();
            sessionStorage.clear();
            this.props.userHasAuthenticated(false);
			this.props.history.push("/login");
        }
	};

	render(){
		const {t} = this.props;

		return (
            <div className="container" style={{paddingTop:"80px"}}>
                <div className="col-xs-12 form-group" align="center">
                    <button style={{fontSize:"1.2em",width:"180px"}} className="btn btn-info" type="button" 
                        onClick={(e)=>this.optionClicked(e,'samples')}>
                        Muestras
                    </button>
                </div>
                <div className="col-xs-12 form-group" align="center">
                    <button style={{fontSize:"1.2em",width:"180px"}} className="btn btn-info" type="button" 
                        onClick={(e)=>this.optionClicked(e,'transfusional_control')}>
                        Hemovigilancia
                    </button>
                </div>
                {/*<div className="col-xs-12 form-group" align="center">
                    <button style={{fontSize:"1.2em",width:"180px"}} className="btn btn-info" type="button" 
                        onClick={(e)=>this.optionClicked(e,'end_transfusion')}>
                        Finalizar Transfusión
                    </button>
                </div>
                <div className="col-xs-12 form-group" align="center">
                    <button style={{fontSize:"1.2em",width:"180px"}} className="btn btn-info" type="button" 
                        onClick={(e)=>this.optionClicked(e,'incidents')}>
                        Incidentes
                    </button>
                </div>
                <div className="col-xs-12 form-group" align="center">
                    <button style={{fontSize:"1.2em",width:"180px"}} className="btn btn-info" type="button" 
                        onClick={(e)=>this.handleLogout(e,'incidents')}>
                        Salir
                    </button>
        </div>*/}
            </div>
		)
			
	}
} 

export default translate('translations') (MenuHandheld);